import angular from 'angular';
import { get } from 'lodash';
import '../services/errors';
import '../services/globals';
import '../services/organization-user';
import '../services/resource-group';
import '../services/role';
import '../services/user';
import './modals/organization-user-delete';
import './modals/organization-users';

const module = angular.module(
  'whyline.controllers.organization-pending-users',
  [
    'whyline.services.organizationuser',
    'whyline.services.globals',
    'whyline.services.resource-group',
    'whyline.services.role',
    'whyline.services.errors',
    'whyline.services.user',
    'whyline.modals.pending-user',
    'whyline.modals.select-place',
  ],
);

const OrganizationPendingUsersController = (
  $scope,
  $uibModal,
  $window,
  UserService,
  OrganizationUserService,
  RoleService,
  GlobalsService,
  ResourceGroupService,
  NotificationService,
  ErrorService,
  dialog,
  $state,
  $timeout,
  $translate,
  PlaceService,
) => {
  'ngInject';
  $scope.title = 'Users';
  $scope.quantityOfItems = 8;
  $scope.organizationId = $state.params.organizationId;

  $scope.currentUser = UserService.GetCurrent();

  const updateData = () => {
    OrganizationUserService.GetPendingAsPromise().then(({ data }) => {
      $scope.users = data;
    });
  };

  updateData();

  $scope.delete = (userId, user) => {
    const n = get(user, 'local.email', '');

    dialog
      .confirm(
        $translate
          .instant('pending_user_{name}_remove_sure')
          .replace('{name}', n),
      )
      .then(() => {
        OrganizationUserService.RemovePendingUser(userId)
          .then(() => {
            const nTag = `<span class="bold">${n || ''}</span>`;
            NotificationService.Success(
              $translate
                .instant('pending_user_{name}_remove_succ')
                .replace('{name}', nTag),
            );
          })
          .catch(ErrorService.handler)
          .finally(() => {
            updateData();
          });
      });
  };

  // Modal
  $scope.open = function(userId) {
    PlaceService.GetAllAsPromise().then(places => {
      const placeModal = $uibModal.open({
        templateUrl: '/templates/components/modals/select-place-modal.html',
        size: 'md',
        controller: 'SelectPlaceModalController',
        controllerAs: 'modal',
        resolve: {
          userId: () => userId,
          places,
        },
      });

      placeModal.result.then(place => {
        if (place === 'cancel') {
          return;
        }

        const placeId = place._id.toString();

        PlaceService.SetCurrent(place);

        RoleService.GetAllAsPromise().then(roles => {
          const modal = $uibModal.open({
            templateUrl:
              '/templates/components/modals/organization-pending-user-modal.html',
            size: 'lg',
            controller: 'OrganizationPendingUserModalController',
            controllerAs: 'modal',
            resolve: {
              userId: () => userId,
              placeId: () => placeId,
              organizationId: () => $scope.organizationId,
              roles: () => roles,
            },
          });

          modal.result.finally(() => {
            PlaceService.SetCurrent(null);

            updateData();
          });
        });
      });
    });
  };
};

module.exports = module.controller(
  'OrganizationPendingUsersController',
  OrganizationPendingUsersController,
);
